import _ from "lodash";
import {
  getOrganizationGradesQuery,
  getOrganizationCoursesQuery,
  getOrganizationFeedQuery,
  getInternalToolGenericDataQuery,
  getOrganizationGlobalConstantsQuery,
} from "./InternalToolsQuery";
import client from "lib/apolloClient/client";

export const getOrganizationFeedQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationFeedQuery,
      variables,
    });
    return _.get(
      _.first(_.get(queryData, "platform.organizationFeed.edges", [])),
      "node",
      {}
    );
  } catch (e) {
    return {};
  }
};

export const getInternalToolGenericDataFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getInternalToolGenericDataQuery,
      variables,
    });
    return _.get(queryData, "platform.internalToolsGenericQuery", {});
  } catch (e) {
    return {};
  }
};

export const writeInternalToolGenericDataToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getInternalToolGenericDataQuery,
      variables,
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const getOrganizationGradesFromCache = ({
  organizationId,
  gradeFilters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationGradesQuery,
      variables: {
        organizationId,
        gradeFilters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationCoursesFromCache = ({
  organizationId,
  courseFilters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationCoursesQuery,
      variables: {
        organizationId,
        courseFilters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationGlobalConstantsFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery(
      {
        query: getOrganizationGlobalConstantsQuery,
        variables: {
          organizationId,
          filter: filters,
        },
      },
      true
    );
  } catch (e) {
    return {};
  }

  return queryData != null ? queryData : {};
};
